module.exports = __webpack_public_path__ + "img/add-pic-banner.c0ef62c6.png";